import { useT } from "../i18n/hooks.ts";
import { Dialog } from "./Dialog.tsx";
import type { CsvUpdateSummary } from "../model/updateProjectFromCsv.ts";

/**
 * Shown after picking a folder for "Update from CSVs…" (TopBar.tsx) — the
 * merge (updateProjectFromCsv.ts) already ran by the time this opens (it's
 * pure, no state touched yet), so this is a preview: counts + any notices,
 * with a chance to back out before the open project actually changes.
 */
export function UpdateFromCsvDialog({
  summary,
  onApply,
  onClose,
}: {
  summary: CsvUpdateSummary;
  onApply: () => void;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <Dialog title={t("updateCsvProject.dialogTitle")} onClose={onClose}>
      <ul className="update-csv-summary">
        <li>{t("updateCsvProject.subBasinsUpdated", { n: summary.subBasinsUpdated })}</li>
        <li>
          {t("updateCsvProject.zonesSummary", {
            updated: summary.zonesUpdated,
            created: summary.zonesCreated,
          })}
        </li>
        <li>
          {t("updateCsvProject.aquifersSummary", {
            updated: summary.aquifersUpdated,
            created: summary.aquifersCreated,
          })}
        </li>
        <li>{t("updateCsvProject.outletsSummary", { created: summary.outletsCreated })}</li>
        {summary.configUpdated && <li>{t("updateCsvProject.configUpdated")}</li>}
      </ul>
      {summary.notices.length > 0 && (
        <ul className="update-csv-notices">
          {summary.notices.map((notice, i) => (
            <li key={i}>{notice}</li>
          ))}
        </ul>
      )}
      <div className="dialog-actions">
        <button className="button" onClick={onApply}>
          {t("updateCsvProject.apply")}
        </button>
        <button className="button" onClick={onClose}>
          {t("common.cancel")}
        </button>
      </div>
    </Dialog>
  );
}
